const RootPageStyledDiv = ({ children }: { children: React.ReactNode }) => {
  return <div className="flex h-full flex-col px-3">{children}</div>
}

export default RootPageStyledDiv
